export const SVH_EXAM_RESULT_URL: string = "https://www.svhexamenresultaat.nl/";
